import React, { useEffect, useState } from "react";
import { RecentFavoritesListItem, SectionHeading } from "../components";
import { Skeleton } from "../components/ui/skeleton";
import { fetchRecentFavorites } from "../utilities/api"; // Import API function

const RecentFavorites = ({data , recentFavorites = [] , isLoading = false}) => {
  const {sectionDetails} = data;
  const hasData = recentFavorites.length > 0;
  return (
    <>
      <div>
        {/* <SectionHeading title="Recent Favorites" /> */}
        {/* Render the section heading */}
        {
          hasData && (
            <SectionHeading
            title={sectionDetails.title}
            icon={sectionDetails.icon}
            link={sectionDetails.link}
          />
          )
        }
      
      </div>
      <div className="mt-4">
        <div className="flex flex-col mb-4 bg-white-50 rounded-xl">
          {isLoading
            ? Array.from({ length: 3 }).map((_, index) => (
                <div
                  key={index}
                  className="p-4 border-b border-gray-200 last:border-b-0"
                >
                  <Skeleton className="w-3/4 h-6 rounded-md" />
                  <Skeleton className="w-1/2 h-4 mt-2 rounded-md" />
                </div>
              ))
            : recentFavorites.map((favorite, index) => (
                <RecentFavoritesListItem key={index} favorite={favorite} />
              ))}
        </div>
      </div>
    </>
  );
};

export default RecentFavorites;
